export default __webpack_public_path__ + "static/media/685.9bb57cf4.png";